import React, { useState } from 'react';
import ModalBackdrop from './ModalBackdrop';

// "[What's this?]" trigger + "About BMR" popup. Self-contained.
// Takes no props: the popup contains only explanatory copy — it does not
// display any computed BMR value, so there is nothing for it to calculate.
// Dismissal (backdrop click, ESC key, Close button) is handled by
// ModalBackdrop; the Close button stays in place for explicit visual affordance.
function BMRPopup() {
  const [show, setShow] = useState(false);

  return (
    <>
      <span className="bmr-link" onClick={() => setShow(true)}>[What’s this?]</span>
      {show && (
        <ModalBackdrop onClose={() => setShow(false)}>
          <div className="popup-content">
            <h3>About BMR</h3>
            <p>
              Basal Metabolic Rate (BMR) is the number of calories your body needs at rest to maintain basic functions like breathing and circulation. It’s calculated using your weight, height, age, and gender.
            </p>
            <button className="btn-secondary" onClick={() => setShow(false)}>Close</button>
          </div>
        </ModalBackdrop>
      )}
    </>
  );
}

export default BMRPopup;
